// extracted by mini-css-extract-plugin
module.exports = {"badges":"AppBadges_badges__oX3Dd","hidden":"AppBadges_hidden__E6op4","qrCodeContainer":"AppBadges_qrCodeContainer__RhdMk","arrow":"AppBadges_arrow__I9vSs"};